import { ReportCrashParams } from "@/domain/dtos/params";
import { z } from "zod";

const DeviceInfoSchema = z.union([
  z.string(),
  z.object({
    os: z.enum(["ios", "android", "windows", "macos", "web"]),
    appVersion: z.string(),
    app: z.string(),
    model: z.string().optional(),
    os_version: z.union([z.string(), z.number()]).nullable().optional(),
  }),
]);

export const ReportCrashParamsSchema: z.ZodType<ReportCrashParams> = z.object({
  error: z.string(),
  exception: z.string(),
  user_id: z.union([z.number().int().positive(), z.undefined()]),
  os: z.string(),
  route: z.any(),
  device: DeviceInfoSchema,
});
